import type { CaseItem } from '../api/types';
import { describeWork, workLabel } from '../lib/works';

export function WorksList({
  items,
  onRemove,
  removeLabel,
}: {
  items: CaseItem[];
  onRemove?: (index: number) => void;
  removeLabel?: string;
}) {
  return (
    <ul className="works">
      {items.map((w, i) => (
        <li key={i}>
          {onRemove && (
            <button type="button" className="btn btn-sm btn-quiet remove" onClick={() => onRemove(i)}>
              {removeLabel}
            </button>
          )}
          <strong>{workLabel(w.type)}</strong>
          <span className="muted small">{describeWork(w)}</span>
        </li>
      ))}
    </ul>
  );
}

export function WorksShort({ items }: { items: CaseItem[] }) {
  return (
    <>
      {items.map((w, i) => (
        <span key={i}>
          {i > 0 && <br />}
          {workLabel(w.type)}
          {w.teeth?.length ? <span className="muted small"> {w.teeth.join(', ')}</span> : null}
        </span>
      ))}
    </>
  );
}
